var _style, _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketingAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgQrWrapper",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 300,
    style: {
      width: "100%",
      height: "100%",
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9, 9)scale(0.95)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".background-color{ fill: transparent; }.dot-color{ fill: #767474; }.corners-square-color-0-0{ fill: #0071BC; }.corners-dot-color-0-0{ fill: #0071BC; }.corners-square-color-1-0{ fill: #0071BC; }.corners-dot-color-1-0{ fill: #0071BC; }.corners-square-color-0-1{ fill: #0071BC; }.corners-dot-color-0-1{ fill: #0071BC; }")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dot-color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 85v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,10,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,10,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 105v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,10,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 135v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,10,140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 185v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,10,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,20,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,20,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15 115v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,20,120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15 145v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,20,150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15 165v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,20,170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15 205v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,20,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,30,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,30,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 125v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,30,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,30,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,30,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,30,170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 195v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,30,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,40,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35 105v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,40,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,40,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,40,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,40,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,40,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,40,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,40,180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35 205v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,40,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,50,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,50,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,50,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,50,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,50,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,50,200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 205v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,50,210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 95v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,60,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 115v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,60,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,60,150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 175v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,60,180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65 85v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,70,90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65 105v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,70,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65 125v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,70,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65 145v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,70,150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65 165v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,70,170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65 185v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,70,190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65 205v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,70,210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75 125v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,80,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75 155v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,80,160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75 195v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,80,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,80,210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85 15v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,90,20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85 65v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,90,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,90,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,90,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,90,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,90,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85 135v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,90,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,90,160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85 165v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,90,170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85 185v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,90,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,90,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,90,210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85 215v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,90,220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85 275v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,90,280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85 285v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,90,290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 95 25v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,100,30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 95 35v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,100,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,100,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,100,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,100,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,100,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 95 115v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,100,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,100,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,100,150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 95 155v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,100,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,100,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,100,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,100,210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 95 235v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,100,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,100,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,100,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 95 275v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,100,280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105 55v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,110,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,110,70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105 75v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,110,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,110,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105 125v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,110,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,110,140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105 145v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,110,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,110,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,110,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,110,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,110,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,110,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,110,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105 265v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,110,270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 115 25v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,120,30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 115 35v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,120,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,120,60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 115 85v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,120,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,120,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,120,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,120,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,120,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,120,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,120,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 15v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,130,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,130,60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 65v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,130,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,130,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,130,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 185v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,130,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,130,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,130,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,130,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,130,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,130,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 275v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,130,280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135 5v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,140,10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135 25v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,140,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,140,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,140,50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135 55v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,140,60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135 75v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,140,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,140,90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135 105v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,140,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,140,190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135 195v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,140,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,140,230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135 245v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,140,250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135 255v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,140,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135 285v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,140,290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 5v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,150,10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 35v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,150,40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 65v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,150,70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 85v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,150,90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 205v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,150,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,150,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,150,230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 235v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,150,240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 155 75v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,160,80)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 155 95v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,160,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 155 105v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,160,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 155 185v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,160,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,160,210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 155 245v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,160,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,160,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,160,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,160,280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 165 5v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,170,10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 165 15v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,170,20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 165 65v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,170,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,170,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,170,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,170,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,170,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,170,270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 165 275v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,170,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,180,10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 175 25v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,180,30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 175 35v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,180,40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 175 55v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,180,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,180,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,180,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,180,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 175 185v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,180,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,180,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,180,210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 175 225v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,180,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,180,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,180,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,180,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,180,270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 175 285v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,180,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,190,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,190,20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185 25v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,190,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,190,60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185 65v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,190,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,190,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185 125v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,190,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185 135v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,190,140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185 155v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,190,160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185 175v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,190,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,190,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,190,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,190,240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185 245v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,190,250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185 265v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,190,270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185 285v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,190,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,200,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,200,60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 95v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,200,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,200,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,200,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,200,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,200,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,200,230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 205 5v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,210,10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 205 25v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,210,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,210,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,210,70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 205 75v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,210,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,210,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,210,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,210,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 205 135v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,210,140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 205 155v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,210,160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 205 175v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,210,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,210,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,210,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,210,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,210,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,210,250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 205 265v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,210,270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 205 285v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,210,290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 215 85v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,220,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,220,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,220,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,220,160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 215 165v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,220,170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 215 195v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,220,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,220,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,220,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,220,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 215 265v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,220,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,230,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,230,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,230,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 225 125v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,230,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,230,160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 225 185v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,230,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,230,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,230,210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 225 225v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,230,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,230,250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 235 105v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,240,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,240,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,240,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,240,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,240,250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 235 255v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,240,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 235 285v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,240,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,250,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,250,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,250,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,250,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,250,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,250,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,250,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,250,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,250,240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 245 245v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,250,250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 255 95v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,260,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 255 115v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,260,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,260,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 255 145v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,260,150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 255 165v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,260,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,260,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,260,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,260,240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 255 255v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,260,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,260,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,260,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,270,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,270,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,270,120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 265 125v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,270,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 265 185v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,270,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,270,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,270,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,270,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,270,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,270,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,270,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,270,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,270,270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 265 275v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,270,280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 275 85v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,280,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,280,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 275 135v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,280,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,280,150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 275 155v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,280,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,280,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,280,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,280,270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 275 285v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,280,290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 95v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,290,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 115v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,290,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,290,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 135v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,290,140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 165v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,290,170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 175v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,290,180)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 195v 5a 5 5, 0, 0, 0, 5 5h 5v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,290,200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 215v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(-90,290,220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 225v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,290,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,290,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,290,260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285 265v 10h 10v -5a 5 5, 0, 0, 0, -5 -5",
    transform: "rotate(90,290,270)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "green-dots"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "corners-square-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 40 5a 35 35 0 1 0 0.1 0zm 0 10a 25 25 0 1 1 -0.1 0Z",
    transform: "rotate(0,40,40)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "corners-dot-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 25 35.714285714285715v 8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, 10.714285714285714 10.714285714285714h 19.285714285714285v -19.285714285714285a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 -10.714285714285714h -8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 10.714285714285714",
    transform: "rotate(-180,40,40)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "corners-square-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 260 5a 35 35 0 1 0 0.1 0zm 0 10a 25 25 0 1 1 -0.1 0Z",
    transform: "rotate(90,260,40)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "corners-dot-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 245 35.714285714285715v 8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, 10.714285714285714 10.714285714285714h 19.285714285714285v -19.285714285714285a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 -10.714285714285714h -8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 10.714285714285714",
    transform: "rotate(-90,260,40)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "corners-square-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 40 225a 35 35 0 1 0 0.1 0zm 0 10a 25 25 0 1 1 -0.1 0Z",
    transform: "rotate(-90,40,260)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "corners-dot-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 25 255.71428571428572v 8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, 10.714285714285714 10.714285714285714h 19.285714285714285v -19.285714285714285a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 -10.714285714285714h -8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 10.714285714285714",
    transform: "rotate(-270,40,260)"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "57px",
    viewBox: "0 0 1088 955",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    x: 117,
    y: 121.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M821.253 426.117C820.131 426.566 819.682 427.912 820.355 429.034L843.466 476.154C867.924 469.871 894.177 481.09 905.62 504.65C918.859 531.576 907.864 563.887 880.938 577.126C854.012 590.364 821.702 579.37 808.463 552.444C796.795 528.884 803.975 501.06 823.945 485.802L800.834 438.682C795 426.79 799.937 412.43 811.829 406.596L986.173 320.658L840.774 25.8203C829.555 2.93336 801.956 -6.49072 779.069 4.72836L517.665 133.523L574.657 249.304C580.491 261.196 575.555 275.557 563.663 281.391L516.543 304.502C522.825 328.96 511.606 355.212 488.046 366.656C461.12 379.894 428.809 368.9 415.571 341.974C402.332 315.048 413.327 282.737 440.253 269.499C463.813 257.831 491.636 265.011 506.894 284.981L554.014 261.87C555.136 261.421 555.585 260.075 554.912 258.953L497.919 143.172L245.041 267.704C256.933 291.712 249.304 320.209 228.437 335.467C225.52 337.711 222.154 339.281 218.788 340.852L215.871 341.974C212.281 343.545 208.467 344.666 204.652 345.34C181.541 349.154 157.981 337.711 147.211 315.721L25.8202 375.407C2.93325 386.626 -6.49069 414.225 4.72839 437.112L247.06 929.18C258.28 952.067 285.878 961.491 308.765 950.272L430.156 890.587C418.039 866.129 426.117 837.184 447.657 821.926C447.657 821.926 452.818 818.56 457.081 816.765C483.559 805.097 514.972 816.316 527.762 842.569L752.143 732.173L571.067 364.636C565.233 352.744 570.17 338.384 582.062 332.55L629.182 309.439C622.899 284.981 634.118 258.728 657.678 247.285C684.604 234.046 716.915 245.041 730.154 271.967C743.392 298.893 732.398 331.204 705.472 344.442C681.912 356.11 654.089 348.93 638.831 328.96L591.711 352.071C590.589 352.52 590.14 353.866 590.813 354.988L771.889 722.525L1061.57 579.818C1084.45 568.599 1093.88 541 1082.66 518.113L995.148 340.403L821.253 426.117ZM349.154 600.013C351.847 598.666 355.437 599.788 356.783 602.481L361.719 612.578C363.066 615.271 361.944 618.861 359.251 620.207C356.559 621.553 352.968 620.431 351.622 617.739L346.686 607.642C345.115 604.949 346.461 601.359 349.154 600.013ZM336.14 586.325L331.203 576.228C329.857 573.536 330.979 569.945 333.672 568.599C336.364 567.253 339.954 568.375 341.301 571.067L346.237 581.165C347.583 583.857 346.461 587.447 343.544 588.794C340.852 590.364 337.486 589.018 336.14 586.325ZM364.636 631.65C367.329 630.304 370.919 631.426 372.265 634.119L377.202 644.216C378.548 646.908 377.426 650.498 374.509 651.845C371.817 653.191 368.226 652.069 366.88 649.377L361.944 639.279C360.598 636.362 361.944 632.997 364.636 631.65ZM222.603 355.885C221.257 353.193 222.378 349.603 225.071 348.257C227.764 346.91 231.354 348.032 232.7 350.725L237.636 360.822C238.983 363.514 237.861 367.105 235.168 368.451C232.476 369.797 228.885 368.675 227.539 365.983L222.603 355.885ZM238.085 387.299C236.739 384.606 237.861 381.016 240.553 379.67C243.246 378.324 246.836 379.446 248.182 382.363L253.119 392.46C254.465 395.152 253.343 398.742 250.426 400.089C247.734 401.435 244.143 400.313 242.797 397.62L238.085 387.299ZM253.567 418.937C252.221 416.244 253.343 412.654 256.036 411.308C258.728 409.961 262.318 411.083 263.665 414L268.601 424.097C269.947 426.79 268.825 430.38 266.133 431.727C263.44 433.073 259.85 431.951 258.504 429.258L253.567 418.937ZM271.742 442.721C274.435 441.375 278.025 442.497 279.371 445.189L284.308 455.287C285.654 457.979 284.532 461.569 281.84 462.915C279.147 464.262 275.557 463.14 274.211 460.447L269.274 450.35C267.703 447.433 268.825 444.067 271.742 442.721ZM297.097 494.553C294.405 495.9 290.815 494.778 289.468 492.085L284.532 481.988C283.186 479.295 284.308 475.705 287 474.359C289.693 473.013 293.283 474.135 294.629 476.827L299.566 486.924C301.136 489.841 300.014 493.207 297.097 494.553ZM310.336 508.241L315.272 518.338C316.619 521.03 315.497 524.62 312.804 525.967C310.112 527.313 306.521 526.191 305.175 523.498L300.239 513.401C298.893 510.709 300.014 507.119 302.707 505.772C305.4 504.202 308.99 505.548 310.336 508.241ZM315.497 544.815C314.151 542.122 315.272 538.532 317.965 537.186C320.658 535.84 324.248 536.961 325.594 539.654L330.53 549.751C331.877 552.444 330.755 556.034 328.062 557.38C325.37 558.726 321.78 557.604 320.433 554.912L315.497 544.815ZM377.651 670.468C376.304 667.776 377.426 664.186 380.119 662.839C382.811 661.493 386.401 662.615 387.748 665.532L392.684 675.629C394.03 678.322 392.908 681.912 389.991 683.258C387.299 684.604 383.709 683.483 382.362 680.79L377.651 670.468ZM405.698 714.672C403.006 716.018 399.415 714.896 398.069 712.203L393.133 702.106C391.786 699.414 392.908 695.824 395.601 694.477C398.294 693.131 401.884 694.253 403.23 696.945L408.166 707.043C409.513 709.96 408.391 713.325 405.698 714.672ZM418.712 728.583L423.649 738.68C424.995 741.373 423.873 744.963 421.18 746.309C418.488 747.656 414.898 746.534 413.552 743.841L408.615 733.744C407.269 731.051 408.391 727.461 411.083 726.115C414 724.544 417.366 725.666 418.712 728.583ZM454.613 801.507C455.96 804.2 454.838 807.79 452.145 809.136C449.452 810.482 445.862 809.361 444.516 806.668L439.58 796.571C438.233 793.878 439.355 790.288 442.048 788.942C444.74 787.596 448.331 788.717 449.677 791.41L454.613 801.507ZM439.131 770.094C440.477 772.786 439.355 776.376 436.663 777.723C433.97 779.069 430.38 777.947 429.034 775.255L424.097 765.157C422.751 762.465 423.873 758.875 426.566 757.528C429.258 756.182 432.848 757.304 434.195 759.997L439.131 770.094Z",
    fill: "#0071BC"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketingAndroid);
export default __webpack_public_path__ + "static/media/TicketingAndroid.447876c420347eb722a93f63d9c22e7b.svg";
export { ForwardRef as ReactComponent };